export default {
    header: {
        title: 'News Feed',
    },
    noauth: {
        warning: 'Note: ',
        warningPartTwo:
            'You are accessing this feature as a Guest and therefore it may not be fully functional.',
        createAccount: 'Create an account',
        warningPartThree:
            'to add more functionality to this feature and many others on this website.',
    },
    followingAndIgnore: {
        following: 'Following',
        users: 'users',
        followingMe: 'Followers',
        ignoring: 'Ignoring',
        followingMeShort: 'Followers',
    },
    compose: {
        title: 'Compose News Post',
        clickHere: 'Post News Feed message',
        label: 'Type your news here',
        charactersRemaining: 'character(s) left',
        charactersOver: 'character(s) too many',
        success: 'Your news item has been posted.',
        noAccess: 'Only premium members can post news.',
    },
    display: {
        displayNewsFrom: 'Display from',
        onlyOnlineModels: 'Only Online',
        byCamscore: 'By CamScore',
    },
    newsCell: {
        minuteAgo: 'minute ago',
        minutesAgo: 'minutes ago',
        online: 'Online',
        viewAll: 'View All News from',
        follow: 'Follow',
        ignore: 'Ignore',
        on: 'on',
        at: 'at',
    },
    // not implemented in first pass; adding for future
    updates: {
        receive: 'Receive news updates in',
        chat: 'Chat Rooms',
        pm: 'Private Messages',
        privateShows: 'Private Shows',
        groupShows: 'Group & Club Shows',
        fromFriends: 'Display news from friends',
    },
    searchBy: {
        noResults: 'There are no news items to display.',
        searchBy: 'Search By',
        showing: 'Showing news matching',
        type: 'news',
    },
    tabs: {
        news: 'News Feed',
        search: 'Search News',
    },
    list: {
        notIgnoring: 'You are not ignoring any users.',
        notFollowing: 'You are not following any users.',
        nobodyFollowingYou: 'No users following you.',
        clickToRemoveIgnore: 'Select a user to stop ignoring them.',
        clickToRemoveFollowee: 'Select a user to stop following them.',
        clickToAddFollower:
            'Select a user that is following you to follow them back.',
    },
    newsSettings: {
        viewAllLink: 'You can also update all Header Notifications',
        viewAllInAppAlertSettings: 'here',
    },
}
